import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=79703926&lang=pug&"
import script from "./Promotions.vue?vue&type=script&lang=js&"
export * from "./Promotions.vue?vue&type=script&lang=js&"
import style0 from "./Promotions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79703926')) {
      api.createRecord('79703926', component.options)
    } else {
      api.reload('79703926', component.options)
    }
    module.hot.accept("./Promotions.vue?vue&type=template&id=79703926&lang=pug&", function () {
      api.rerender('79703926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/promotions/Promotions.vue"
export default component.exports